import { render, staticRenderFns } from "./ContractPresentation.vue?vue&type=template&id=3dd553ea&scoped=true"
import script from "./ContractPresentation.vue?vue&type=script&lang=js"
export * from "./ContractPresentation.vue?vue&type=script&lang=js"
import style0 from "./ContractPresentation.vue?vue&type=style&index=0&id=3dd553ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd553ea",
  null
  
)

export default component.exports